import { useEffect, useState } from 'react';
import { supabase } from '../../supabaseClient';

export interface ShiftFormState {
  requiredCount: number;
  selectedIds: string[];
}

export interface JobShiftsRepository {
  listShifts(leadId: string): Promise<any[] | null>;
}

export const supabaseJobShiftsRepository: JobShiftsRepository = {
  async listShifts(leadId) {
    const { data } = await supabase.from('event_shifts').select('*').eq('lead_id', leadId).order('event_date', { ascending: true });
    return data;
  },
};

export const useJobShifts = (
  expandedInquiry: string | null,
  repository: JobShiftsRepository = supabaseJobShiftsRepository,
) => {
  const [shifts, setShifts] = useState<any[]>([]);
  const [shiftForms, setShiftForms] = useState<Record<string, ShiftFormState>>({});

  useEffect(() => {
    if (!expandedInquiry) return;
    repository.listShifts(expandedInquiry)
      .then(data => {
        if (!data) return;
        setShifts(data);
        const forms: Record<string, ShiftFormState> = {};
        data.forEach(shift => {
          forms[shift.id] = { requiredCount: shift.staff_roster?.required_count || 1, selectedIds: [] };
        });
        setShiftForms(forms);
      });
  }, [expandedInquiry, repository]);

  return { shifts, setShifts, shiftForms, setShiftForms };
};
